var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H16.067L.852 16h15.12l.07-.072L32 0z",
    fill: "url(#paint0_linear_1912_183)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32H0h32zM16.043 15.928l-.071.072h.143l-.072-.072z",
    fill: "url(#paint1_linear_1912_183)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.067 0H0v16.896V16h.852L16.067 0z",
    fill: "url(#paint2_linear_1912_183)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.972 16H.852L0 16.896V32l15.972-16z",
    fill: "url(#paint3_linear_1912_183)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.115 16h-.143L0 32h32L16.115 16z",
    fill: "url(#paint4_linear_1912_183)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.852 16H0v.896L.852 16z",
    fill: "url(#paint5_linear_1912_183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1912_183",
    x1: -5.711,
    y1: 29.244,
    x2: 24.066,
    y2: -0.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#C757BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#CD5CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E8744F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#F88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#FF8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1912_183",
    x1: 10.337,
    y1: 37.764,
    x2: 24.851,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1912_183",
    x1: -0.337,
    y1: 8.844,
    x2: 9.844,
    y2: -1.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1912_183",
    x1: -5.533,
    y1: 29.422,
    x2: 24.245,
    y2: -0.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD4CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#AD4CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#B25093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#CA6545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#D87213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#DE7700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE7700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1912_183",
    x1: 10.337,
    y1: 37.764,
    x2: 24.851,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1912_183",
    x1: 3.664,
    y1: 12.845,
    x2: 13.846,
    y2: 2.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#0098DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#4771DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.2dd81aee7459ca2a7a97d10e148b7b26.svg";
export { ForwardRef as ReactComponent };